import React from 'react';

const Loader = () => {
    return (
        <div className="container-fluid loader-wrap">
            <div className="row h-100">
                <div className="col-10 col-md-6 col-lg-5 col-xl-3 mx-auto text-center align-self-center">
                    <div className="circular-loader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <p className="mt-4"> <strong>لطفا منتظر بمانید...</strong></p>
                </div>
            </div>
        </div>
    );
};

export default Loader;
